/**
 * @module app.um
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-framework';

export function getUtilizationManagementQueueNavigationTypes(): DynamicViews {
    return {
        'UM.MyAuths': [
            {
                title: 'um:queueTypes.myAuths.$title',
                url: PLATFORM.moduleName('app/um/components/queues/my-auths-queue-navigation')
            }
        ],
        'UM.Routing': [
            {
                title: 'um:queueTypes.routing.$title',
                url: PLATFORM.moduleName('app/um/components/queues/routing-queue-navigation')
            }
        ],
        'UM.Portal': [
            {
                title: 'um:queueTypes.portal.$title',
                url: PLATFORM.moduleName('app/um/components/queues/routing-queue-navigation')
            }
        ],
    };
}
